module.exports = __webpack_public_path__ + "static/media/pink.475ab991.svg";